const moment = require('moment');
const API_TOKEN = window.MIXPANEL_API_TOKEN;
const { getUserObject } = require('../../services/userService.js');

// const DEFAULT_CONFIG = {
//   // super properties cookie expiration (in days)
//   cookie_expiration:          365,
//
//   // super properties span subdomains
//   cross_subdomain_cookie:     true,
//
//   // if this is true, the window.mixpanel cookie or localStorage entry
//   // will be deleted, and no user persistence will take place
//   disable_persistence:        false,
//
//   // type of persistent store for super properties (cookie/
//   // localStorage) if set to 'localStorage', any existing
//   // window.mixpanel cookie value with the same persistence_name
//   // will be transferred to localStorage and deleted
//   persistence:                'cookie',
//
//   // name for super properties persistent store
//   persistence_name:           '',
//
//   // names of properties/superproperties which should never
//   // be sent with track() calls
//   property_blacklist:         [],
//
//   // if this is true, window.mixpanel cookies will be marked as
//   // secure, meaning they will only be transmitted over https
//   secure_cookie:              false,
//
//   // the amount of time track_links will
//   // wait for window.mixpanel's servers to respond
//   track_links_timeout:        300,
//
//   // if this is true, window.mixpanel will automatically determine
//   // City, Region and Country data using the IP address of
//   //the client
//   ip: 			      true,
//
//   // should we track a page view on page load
//   track_pageview:             true,
//
//   // if you set upgrade to be true, the library will check for
//   // a cookie from our old js library and import super
//   // properties from it, then the old cookie is deleted
//   // The upgrade config option only works in the initialization,
//   // so make sure you set it when you create the library.
//   upgrade:                    false
// };

function init(profile) {
  // const HTTP_PROTOCOL = (('https:' === document.location.protocol) ? 'https://' : 'http://');
  // const DEFAULT_CONFIG = {
  //   'api_host':               HTTP_PROTOCOL + 'api.window.mixpanel.com',
  //   'app_host':               HTTP_PROTOCOL + 'window.mixpanel.com',
  //   'autotrack':              true,
  //   'cdn':                    HTTP_PROTOCOL + 'cdn.mxpnl.com',
  //   'cross_subdomain_cookie': true,
  //   'persistence':            'cookie',
  //   'persistence_name':       '',
  //   'cookie_name':            '',
  //   'loaded':                 function() {},
  //   'store_google':           true,
  //   'save_referrer':          true,
  //   'test':                   false,
  //   'verbose':                false,
  //   'img':                    false,
  //   'track_pageview':         true,
  //   'debug':                  false,
  //   'track_links_timeout':    300,
  //   'cookie_expiration':      365,
  //   'upgrade':                false,
  //   'disable_persistence':    false,
  //   'disable_cookie':         false,
  //   'secure_cookie':          false,
  //   'ip':                     true,
  //   'property_blacklist':     []
  // };

  if (!window.mixpanel) {
    return
  }

  window.mixpanel.init(API_TOKEN, {
    ignore_dnt: true,
    // track_pageview: true,
    record_sessions_percent: 0
  });

  if (profile?.email) {
    window.mixpanel.identify(profile.email);
    _setUserProperties(profile)
  } else {
    // pre-login → post-login funnel visibility
    window.mixpanel.identify(); // anonymous ID
  }
}

function fixFormats(data) {
  let payload = {};
  for (var prop in data) {
    let value = data[prop];
    ///
    /// convert date to window.mixpanel date format
    ///
    if ((value instanceof Date || value instanceof moment) && moment(value).isValid(value)) {
      value = moment.utc(moment(value).format('YYYY-MM-DD')).toISOString().split('.')[0];
    }
    payload[prop] = value;
  }
  return payload;
}

// Track an event. This is the most important and frequently used window.mixpanel function.
function track(event_name, properties, callback) {
  properties = fixFormats(properties);
  window.mixpanel && window.mixpanel.track && window.mixpanel.track(
    event_name,
    properties,
    callback
  );
}

// Track clicks on a set of document elements. Selector must be a valid query.
// Elements must exist on the page at the time track_links is called.
function trackLinks(query, event_name, properties) {
  window.mixpanel.track_links(query, event_name, properties);
}

// Track form submissions. Selector must be a valid query.
function trackForms(query, event_name, properties) {
  window.mixpanel.track_forms(query, event_name, properties);
}

// Time an event by including the time between this call and a later 'track' call for the same event in the properties sent with the event.
function timeEvent(event_name) {
  window.mixpanel.time_event(event_name);
}

// Register a set of super properties, which are included with all events.
// This will overwrite previous super property values.
function register(properties, days) {
  window.mixpanel.register(properties, days);
}

// Register a set of super properties only once.
// This will not overwrite previous super property values, unlike register().
function registerOnce(properties, default_value, days) {
  window.mixpanel.register_once(properties, default_value, days);
}

// Delete a super property stored with the current user.
function unregister(property) {
  window.mixpanel.unregister(property);
}

// Identify a user with a unique ID instead of a window.mixpanel randomly generated distinct_id.
// If the method is never called, then unique visitors will be identified by a UUID generated the first time they visit the site.
function identify(unique_id) {
  window.mixpanel.identify(unique_id);
}

// Clears super properties and generates a new random distinct_id for this instance.
// Useful for clearing data when a user logs out.
function reset() {
  window.mixpanel.reset();
}

// Returns the current distinct id of the user.
// This is either the id automatically generated by the library or the id that has been passed by a call to identify().
function getDistinctId() {
  return window.mixpanel.get_distinct_id();
}

// Create an alias, which window.mixpanel will use to link two distinct_ids going forward (not retroactively).
// Multiple aliases can map to the same original ID, but not vice-versa.
// Aliases can also be chained - the following is a valid scenario:
//
// window.mixpanel.alias('new_id', 'existing_id');
// ...
// window.mixpanel.alias('newer_id', 'new_id');
//
// If the original ID is not passed in, we will use the current distinct_id - probably the auto-generated GUID.
function alias(alias, original) {
  window.mixpanel.alias(alias, original);
}

// Update the configuration of a window.mixpanel library instance.
//
// The default config is:
//
// {
//   // super properties cookie expiration (in days)
//   cookie_expiration:          365
//
//   // super properties span subdomains
//   cross_subdomain_cookie:     true
//
//   // if this is true, the window.mixpanel cookie or localStorage entry
//   // will be deleted, and no user persistence will take place
//   disable_persistence:        false
//
//   // type of persistent store for super properties (cookie/
//   // localStorage) if set to 'localStorage', any existing
//   // window.mixpanel cookie value with the same persistence_name
//   // will be transferred to localStorage and deleted
//   persistence:                'cookie'
//
//   // name for super properties persistent store
//   persistence_name:           ''
//
//   // names of properties/superproperties which should never
//   // be sent with track() calls
//   property_blacklist:         []
//
//   // if this is true, window.mixpanel cookies will be marked as
//   // secure, meaning they will only be transmitted over https
//   secure_cookie:              false
//
//   // the amount of time track_links will
//   // wait for window.mixpanel's servers to respond
//   track_links_timeout:        300
//
//   // if this is true, window.mixpanel will automatically determine
//   // City, Region and Country data using the IP address of
//   //the client
//   ip: 			      true
//
//   // should we track a page view on page load
//   track_pageview:             true
//
//   // if you set upgrade to be true, the library will check for
//   // a cookie from our old js library and import super
//   // properties from it, then the old cookie is deleted
//   // The upgrade config option only works in the initialization,
//   // so make sure you set it when you create the library.
//   upgrade:                    false
// }
function setConfig(config) {
  window.mixpanel.set_config(config);
}

// returns the current config object for the library.
function getConfig() {
  return window.mixpanel.get_config();
}

// Returns the value of the super property named property_name.
// If no such property is set, get_property() will return the undefined value.
function getProperty(property_name) {
  return window.mixpanel.get_property(property_name);
}

// Set properties on a user record.
function peopleSet(prop, to, callback) {
  window.mixpanel.people.set(prop, to, callback);
}

// Set properties on a user record, only if they do not yet exist.
// This will not overwrite previous people property values, unlike people.set().
function peopleSetOnce(prop, to, callback) {
  window.mixpanel.people.set_once(prop, to, callback);
}

// Increment/decrement numeric people analytics properties.
function peopleIncrement(prop, by, callback) {
  window.mixpanel.people.increment(prop, by, callback);
}

// Append a value to a list-valued people analytics property.
function peopleAppend(prop, value, callback) {
  window.mixpanel.people.append(prop, value, callback);
}

// Merge a given list with a list-valued people analytics property, excluding duplicate values.
function peopleUnion(prop, value, callback) {
  window.mixpanel.people.union(prop, value, callback);
}

// Record that you have charged the current user a certain amount of money.
// Charges recorded with track_charge() will appear in the window.mixpanel revenue report.
function peopleTrackCharge(amount, properties, callback) {
  window.mixpanel.people.track_charge(amount, properties, callback);
}

// Permanently clear all revenue report transactions from the current user's people analytics profile.
function peopleClearCharges(callback) {
  window.mixpanel.people.clear_charges(callback);
}

// Permanently deletes the current people analytics profile from window.mixpanel (using the current distinct_id).
function peopleDeleteUser() {
  window.mixpanel.people.delete_user();
}

function _setUserProperties(profile) {
  const { email, first_name, last_name, full_name, user_id, role, company_id, company_name, user_segment } = getUserObject(profile);

  window.mixpanel?.people?.set({
    '$email': email,
    '$first_name': first_name,
    '$last_name': last_name,
    '$full_name': full_name,
    'User Id': user_id,
    'Role': role,
    'Company Id': company_id,
    'Company Name': company_name,
    'User Segment': user_segment
  });
}

module.exports = {
  init: init,

  // push: push,
  // disable: disable,

  track: track,
  trackLinks: trackLinks,
  trackForms: trackForms,
  timeEvent: timeEvent,

  register: register,
  registerOnce: registerOnce,
  unregister: unregister,
  getProperty: getProperty,

  identify: identify,
  reset: reset,
  getDistinctId: getDistinctId,
  alias: alias,

  setConfig: setConfig,
  getConfig: getConfig,

  peopleSet: peopleSet,
  peopleSetOnce: peopleSetOnce,
  peopleIncrement: peopleIncrement,
  peopleAppend: peopleAppend,
  peopleUnion: peopleUnion,
  peopleTrackCharge: peopleTrackCharge,
  peopleClearCharges: peopleClearCharges,
  peopleDeleteUser: peopleDeleteUser

};
